import OrderAcceptance from "./OrderAcceptance";
export default OrderAcceptance;